import { render, staticRenderFns } from "./xcombosDetalle.vue?vue&type=template&id=4ad3988e"
import script from "./xcombosDetalle.vue?vue&type=script&lang=js"
export * from "./xcombosDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports